import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "info" }
const _hoisted_2 = {
  key: 1,
  class: "name"
}
const _hoisted_3 = {
  key: 0,
  class: "children-control"
}
const _hoisted_4 = { class: "count" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Image = _resolveComponent("Image")
  const _component_ApolloLink = _resolveComponent("ApolloLink")
  const _component_Ellipsis = _resolveComponent("Ellipsis")
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["node-card", {expandable: !!$options.children_count, expanded: !!$options.children_count && $props.expanded}]),
    onClick: _cache[1] || (_cache[1] = $event => (!!$options.children_count && _ctx.$emit('toggle')))
  }, [
    _createVNode(_component_Image, {
      class: "avatar",
      size: "4rem",
      shape: "circle",
      "initials-size": "1.4rem",
      src: $options.avatar_url,
      name: $options.display_name
    }, null, 8 /* PROPS */, ["src", "name"]),
    _createElementVNode("div", _hoisted_1, [
      ($options.entity_href)
        ? (_openBlock(), _createBlock(_component_ApolloLink, {
            key: 0,
            class: "name",
            text: $options.display_name,
            href: $options.entity_href,
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
          }, null, 8 /* PROPS */, ["text", "href"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($options.display_name), 1 /* TEXT */)),
      ($options.title)
        ? (_openBlock(), _createBlock(_component_Ellipsis, {
            key: 2,
            class: "title"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($options.title), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ]),
    (!!$options.children_count)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString($options.children_count), 1 /* TEXT */),
          _createVNode(_component_Icon, {
            icon: $props.expanded ? 'chevron-down' : 'chevron-right',
            size: "1.6rem",
            stroke: "var(--gray-600)"
          }, null, 8 /* PROPS */, ["icon"])
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}